import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "refresh.icon",
  "use": "refresh.icon-usage",
  "viewBox": "-5318 -7712.901 26.855 36.926",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-5318 -7712.901 26.855 36.926\" id=\"refresh.icon\"><path d=\"M17.428,9.392v5.035l6.714-6.714L17.428,1V6.035A13.4,13.4,0,0,0,6.081,26.613l2.451-2.451a9.853,9.853,0,0,1-1.175-4.7A10.079,10.079,0,0,1,17.428,9.392Zm11.346,2.921-2.451,2.451a10.054,10.054,0,0,1-8.9,14.771V24.5l-6.714,6.714,6.714,6.714V32.891A13.4,13.4,0,0,0,28.774,12.313Z\" transform=\"translate(-5322 -7713.901)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/refresh.icon.svg
// module id = bY0T
// module chunks = 13